<template>
  <div id="three-list">
    <div class="box-container list-items">
      <div class="box flex-around" v-if="menus.length>0">
        <div class="list-item" @click="gotoDuties" v-if="menus.indexOf('职责清单') != -1">
          <div class="item-icon center">
            <van-icon class="iconfont" class-prefix="icon" name="zhize" color="#ffffff" size="20px"/>
          </div>
          <div class="item-name">职责清单</div>
        </div>
        <div class="list-item" @click="gotoMatter" v-if="menus.indexOf('事项清单') != -1">
          <div class="item-icon center">
            <van-icon class="iconfont" class-prefix="icon" name="shixiang" color="#ffffff" size="20px"/>
          </div>
          <div class="item-name">事项清单</div>
        </div>
        <div class="list-item" v-if="menus.indexOf('审批清单') != -1">
          <div class="item-icon center">
            <van-icon class="iconfont" class-prefix="icon" name="shenpi" color="#ffffff" size="18px"/>
          </div>
          <div class="item-name">审批清单</div>
        </div>
      </div>
    </div>
    <div class="box-container matter-list">
      <div class="box" v-if="!emptyShow">
        <ServiceItemLandscape v-for="(item,index) in list" :key="index" :data="item" @matterHandle="matterHandle"/>
      </div>
      <Error :type="'empty'" v-else></Error>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import {Toast} from "vant";
import {queryMattersDepartments, queryMobileItemListsData, queryMobileResponsibilityData} from '@/api/three-list/index'

export default {
name: "ThreeList",
  components: {
    ServiceItemLandscape: () => import("./components/ServiceItemLandscape"),
  },
  data() {
    return {
      params:{
        orgId: '',//部门id
      },
      menus: [],
      orgArray: [],
      list: [],
      emptyShow: false
    }
  },
  created() {
    window.history.pushState(null, null, document.URL)
    this.init();
  },
  methods:{
    init() {
      this.getMenus();
      this.getDectionary();
    },
    getMenus(){
      this.menus = [];
      const keys = ['listConfig'];
      http.get('/param/keys.htm', {keys: keys.join()}).then(resp=>{
        if (!resp || resp.code != 200) {
          Toast(`获取系统参数${dictionaryKey}失败`)
        } else {
          keys.forEach((item, index) => {
            let array = [];
            if (typeof resp.data[item] == 'string') {
              array = JSON.parse(resp.data[item])
            } else {
              array = resp.data[item]
            }
            array.forEach(item => {
              this.menus.push(item.listName);
            })
          })
        }
      });
    },
    getList() {
      this.emptyShow = false;
      this.mixinShowLoading();
      let params = {
        sxmcLike: this.params.sxmcLike,
        orgId: this.params.orgId,
        fwdxId: this.params.fwdxId,
        sxxzId: this.params.sxxzId,
        blmsId: this.params.blmsId,
        sxbhLike: this.params.sxbhLike
      };
      queryMobileItemListsData(params).then(res => {
        if(res.code && res.code == 200) {
          if (res.data.length > 0) {
            this.list = res.data || [];
            this.list.length > 0? this.emptyShow = false : this.emptyShow = true
            this.mixinClearLoading();
          } else {
            queryMobileResponsibilityData({orgId: params.orgId}).then(resp => {
              if (resp.code && resp.code == 200) {
                this.list = resp.data;
                this.list.length > 0? this.emptyShow = false : this.emptyShow = true
                this.mixinClearLoading();
              }
            })
          }
        }
      })
    },
    gotoDuties() {
      this.$router.push('/threeList/duties');
    },
    gotoMatter(){
      this.$router.push('/threeList/matter');
    },
    routerTo(url){
      this.$router.push(url);
    },

    // 列表点击事件
    matterHandle(item) {
      this.$router.push({
        path: '/threeList/matter/detail',
        query: {
          id: item.ID
        }
      })
    },
    //  获取数据字典
    getDectionary() {
      let self = this;
      const keys = [
        'listOrgType'//部门类别
      ];
      http.get('/param/keys.htm', {keys: keys.join()}).then(resp=>{
        if (!resp || resp.code != 200) {
          Toast(`获取系统参数${dictionaryKey}失败`)
        } else {
          let array = [];
          if (typeof resp.data['listOrgType'] == 'string') {
            array = JSON.parse(resp.data['listOrgType'])
          } else {
            array = resp.data['listOrgType']
          }
          this.orgArray = array;
          array.forEach((item, index) => {
            queryMattersDepartments({typeId: item.id}).then(res => {
              if(res.code && res.code == 200) {
                this.$set(this.orgArray[index], 'list', res.data || []);
                if(this.orgArray[index].list.length > 0) {
                  this.params.orgId = this.orgArray[index].list[0].ORGID;
                  self.getList();
                  return
                }
              }
            })
          })
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.page-title,.item-icon{
  background-color: var(--main-color);
}
.page-title{
  height:48px;
  color:#FFFFFF;
  font-weight: bold;
  @extend .font18;
}

.box-container{
  padding:15px;
  .box{
    border-radius: 5px;
  }
  &.list-items{
    padding-bottom: 0;
  }
}
.list-items{
  position: relative;
  z-index:0;
  &::after{
    content: '';
    width: 120%;
    height: 100px;
    position: absolute;
    left: -10%;
    top: 0;
    border-radius: 0 0 50% 50%;
    background-color: var(--main-color);
    z-index:1;
  }
  .box{
    background-color: #ffffff;
    position: relative;
    z-index:2;
  }
  .list-item{
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content:center;
    padding:20px 0;
    .item-icon{
      width:52px;
      height:52px;
      padding:10px;
      border-radius: 5px;
      position:relative;
      z-index: 3;
      box-sizing: border-box;
      overflow: hidden;
      &::after{
        position:absolute;
        content:"";
        display: block;
        top: 15px;
        left: 13px;
        width:70.71px;
        height:70.71px;
        background: linear-gradient(180deg,rgba(255,255,255,0.01),rgba(255,255,255,0.2));
        background: -webkit-linear-gradient(180deg,rgba(255,255,255,0.01),rgba(255,255,255,0.2));
        background: -moz-linear-gradient(180deg,rgba(255,255,255,0.01),rgba(255,255,255,0.2));
        background: -o-linear-gradient(180deg,rgba(255,255,255,0.01),rgba(255,255,255,0.2));
        transform:rotate(135deg);
        z-index: 4;
      }

    }
    .item-name{
      color:#333333;
      margin-top:12px;
      @extend .font16;
    }
  }

}
.empty{
  margin-top: 100px;
}
</style>